import { render } from "./CaseInformation.vue?vue&type=template&id=3e94274a&scoped=true"
import script from "./CaseInformation.vue?vue&type=script&lang=js"
export * from "./CaseInformation.vue?vue&type=script&lang=js"

import "./CaseInformation.vue?vue&type=style&index=0&id=3e94274a&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e94274a"],['__file',"src/components/sendOuts/CaseInformation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3e94274a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3e94274a', __exports__)) {
    console.log('reload')
    api.reload('3e94274a', __exports__)
  }
  
  module.hot.accept("./CaseInformation.vue?vue&type=template&id=3e94274a&scoped=true", () => {
    console.log('re-render')
    api.rerender('3e94274a', render)
  })

}


export default __exports__